<template>
  <div class="all">
    <div class="top-page">
      <router-link to="../" class="button">←　ヘルプページトップへ戻る</router-link>
      <!-- <div v-if="isAgent" style="float:right;padding-right:100px;"> -->
      <div  style="float:right;padding-right:100px;">
        <input type="checkbox" id="demo01" checked  />
        <label for="demo01" data-on-label="isAgent" data-off-label="Off" @click="isAgentButton=!isAgentButton"></label>
      </div>
    </div>    
    <div class="body-help">
      <div id="menu">
        <!-- <button v-if="isAgentButton && isAgent" class="button menu-card-major"> -->
        <button v-if="isAgentButton" class="button menu-card-major">
          <router-link style="text-align:center; color:red;" to="./input">
            項目編集
          </router-link>
        </button>      
        <button v-for="(helpItem, index) in sortedHelpItemsBySort"
          :key="index"
          class="button menu-card-small"
          v-bind:class="{'menu-card-hover' : isActive == helpItem.item_id}" 
          @click="toggleAction(helpItem.item_id)"
        >
          {{getSubString(helpItem.item, 16)}}
        </button>      
      </div>
      <div class="qa">
        <ul>
          <span
            v-for="(help, index2) in sortedHelpsBySort"
            :key="index2"
            @mouseover="cbStatusHover=help"
          >
            <div
              style="border:solid 1px black"
              class="qa-card"
              @click="toggleShow(index2)"
              v-bind:class="{show:isShow[index2],notshow:!isShow[index2]}"
              v-if="isActive== help.item_id" 
            >        
              <li>
                <h1 v-if="!isShow[index2]">▶︎ {{help.question}}</h1>
                <h1 v-if="isShow[index2]">▼ {{help.question}}</h1>
                <div v-if="isShow[index2]" id="preview" class="content ql-editor test-test" v-html="help.answer"></div>
              </li>
            </div>
          </span>  
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
//import Loading from '@/components/animations/Loading'

export default {
  name: "HelpBody",
  componentName: "HelpBody",
  /*components:{
    loading
  },*/
  computed: {
    ...mapState("help", ["helps", "helpItems", "isLoading", "active"]),
    ...mapState("auth", ["user"]),
    sortedHelpItemsBySort() {
      console.debug('*** Start *** sortedHelpItemsBySort')
      return this.helpItems.sort((a, b) => {
        return a.sort_id < b.sort_id ? -1 : a.sort_id > b.sort_id ? 1 : 0;
      });
    },
    sortedHelpsBySort() {
      console.debug('*** Start *** sortedHelpsBySort')
      return this.box.sort((a, b) => {
        return a.sort_id < b.sort_id ? -1 : a.sort_id > b.sort_id ? 1 : 0;
      });
    },
  },
  data() {
    return {
      isActive: 1,
      isShow: [],
      box:[],
      isAgentButton:true,
    };
  },
  methods: {
    toggleAction(index){
      console.debug('*** Start *** toggleAction')
      console.debug('index: ' + JSON.stringify(index))
      //this.$store.dispatch('help/tabLoading');
      this.box=[]
      for(var i in this.helps){
        if(this.helps[i].item_id == index){
          this.box.push(this.helps[i])
        }
      }
      this.isActive = index
      console.debug('*** End *** toggleAction')
    },
    toggleShow: function(index2) {
      console.debug('*** Start *** toggleShow')
      console.debug('index2: ' + JSON.stringify(index2))
      this.$set(this.isShow, index2, !this.isShow[index2]);
      console.debug('*** End *** toggleShow')
    },
    getSubString (m, num) {
      if (m) {
        return m.length < num ? m : m.substring(0, num - 3) + '...'
      } else {
        return 'no title'
      }
    },
  },
  mounted() {
    console.debug('*** Start *** mounted')
    this.$store.dispatch("help/getHelpItem");
    this.$store.dispatch("help/getHelp");
    this.isActive = this.active
    this.box=[]
    setTimeout(() => {
      this.$store.dispatch("help/getHelp")
      this.$store.dispatch("help/getHelpItem")
    }, 500) 
    setTimeout(() => {       
      for(var i in this.helps){
        if(this.helps[i].item_id == this.active){
          this.box.push(this.helps[i])
        }
      }
    }, 1000)
    console.debug('*** End *** mounted')    
  },
  
};
</script>


<style scoped>
.body-help{
  width:90%;
  margin:100px auto;
}
.help-header {
  padding-top: 10px;
  padding-bottom: 10px;
  display: flex;
  /*justify-content: center;*/
  color: white;
  background: #f2f2f2;
}

/*左側メニュー*/
#menu {
  display: block;
  float: left;
  width: 25%;
  /* background-color: #f2f2f2; */
  height:1000px;
  overflow-y: scroll;
}
#menu::-webkit-scrollbar {
  width: 10px;
}
#menu::-webkit-scrollbar-thumb {
  background: #E53787;
}
#menu::-webkit-scrollbar-track-piece:start {
  border-radius: 10px;
  background: silver;
}
#menu::-webkit-scrollbar-track-piece:end {
  border-radius: 10px;
  background: silver;
}
#menu p {
  margin: 10px;
}
#menu ul {
  /*flex: 100%;*/
  margin: 6px 0 0 12%;
  padding: 60px 2% 2%;
  list-style: none;
}
#menu li {
  display: inline;
  padding: 0;
  margin: 0;
}
#menu li a {
  display: block;
  background-color: #ffffff;
  padding: 3px 10px;
  text-decoration: none;
  color: #000000;
  min-height: 75px;
  width: 86%;
  margin: 0 auto;
  text-align: center;
  font-size: 19px;
}
#menu li a:hover {
  background-color: #96a8af;
  color: #000;
}
#menu li a.active {
  background-color: rgba(15, 165, 192, 1);
  color: #ffffff;
}
.menu-card-major {
  font-size:14px;
  text-align: left;
  /* padding-left:10px; */
  color:#ff0000;
  background-color: white;
  margin-top:5px;
  margin-bottom:5px;
  /* margin-left:0px; */
  height: 70px;
  width: 75%;
  border: solid #ff0000;
  /* border-top:none;
  border-left:none; */
  position:relative;
}
.menu-card-major:hover {
  background-color: rgb(240, 167, 184);
  color: white;
  /* cursor:pointer; */
}
.menu-card-major a {
  text-decoration: none;
  display: block;
  width: 100%;
  height: 100%;
}
.menu-card-major a:link {
  color: black;
}
.menu-card-major a:visited {
  color: black;
}
.menu-card-major a:hover {
  color: black;
}
.menu-card-major a:active {
  color: black;
}
.menu-card-small {
  font-size:14px;
  text-align: left;
  /* padding-left:10px; */
  color:black;
  background-color: white;
  margin-top:5px;
  margin-bottom:5px;
  /* margin-left:0px; */
  height: 70px;
  width: 75%;
  border: solid #000000;
  /* border-top:none;
  border-left:none; */
  position:relative;
}
.menu-card-small:hover {
  background-color: rgb(240, 167, 184);
  color: white;
  /* cursor:pointer; */
}
.menu-card-small a {
  text-decoration: none;
  display: block;
  width: 100%;
  height: 100%;
}
.menu-card-small a:link {
  color: black;
}
.menu-card-small a:visited {
  color: black;
}
.menu-card-small a:hover {
  color: black;
}
.menu-card-small a:active {
  color: black;
}
.menu-card-hover{
  background-color: #E53860;
  color: white;
  position:relative;
}
.menu-card-hover:hover{
  background-color: #E53860;
  color: white;
  cursor:auto;
}
.menu-card-hover a {
  text-decoration: none;
  display: block;
  width: 100%;
  height: 100%;
}
.menu-card-hover a:link {
  color: white;
}
.menu-card-hover a:visited {
  color: white;
}
.menu-card-hover a:hover {
  color: white;
}
.menu-card-hover a:active {
  color: white;
}

/*右側Q&A*/
.qa {
  /* background-color: #f2f2f2; */
  width: 75%;
  padding: 0px 30px 30px 30px;
  text-align: left;
  float: right;
  max-height:1000px;
  overflow-y: scroll;
}
.qa::-webkit-scrollbar {
  width: 10px;
}
.qa::-webkit-scrollbar-thumb {
  background: #E53787;
}
.qa::-webkit-scrollbar-track-piece:start {
  border-radius: 10px;
  background: silver;
}
.qa::-webkit-scrollbar-track-piece:end {
  border-radius: 10px;
  background: silver;
}
.qa h1 {
  font-weight: 700;
  font-size: 35px;
  margin: 10px 15px 10px 45px;
  padding: 10px;
}
.qa-card {
  background-color: #ffffff;
  margin: 15px auto;
  min-height: 0;
  min-width: 0;
  border-radius: 5px;
  max-width: 90%;
  min-width: 90%;
  cursor: pointer;
  max-height:1000px;
  overflow-y: scroll; 
}
.qa-card.show::-webkit-scrollbar {
  width: 10px;
}
.qa-card.show::-webkit-scrollbar-thumb {
  background: #E53787;
}
.qa-card.show::-webkit-scrollbar-track-piece:start {
  border-radius: 10px;
  background: silver;
}
.qa-card.show::-webkit-scrollbar-track-piece:end {
  border-radius: 10px;
  background: silver;
}
.qa-card.notshow{
  padding-right:10px;
}
.qa-card.notshow h1:hover {
  color: #96a8af;
}
.qa-card.notshow h1:hover {
  color: #96a8af;
}
.test-test{
  padding:30px 50px;
}
ul {
  list-style: none;
}
.card-header-title{
  padding-left:20%;
  font-size:20px;
}
.top-page{
  text-align:left;
  margin-left:5%;
  margin-top:30px;
}

/* isAgentボタン */
input {
  display: none;
}
input+label,
input+label::before,
input+label::after {
  -webkit-transition: all .2s;
  transition: all .2s;
}
input+label {
  display: inline-block;
  position: relative;
  width: 120px;
  height: 48px;
  border-radius: 24px;
  cursor: pointer;
}
input+label::before {
  display: block;
  content: attr(data-off-label);
  position: absolute;
  top: 12px;
  right: 7px;
  color: #fff;
  font-family: Arial, sans-serif;
  font-size: 18px;
}
input+label::after {
  content: '';
  position: absolute;
  top: 2px;
  left: 2px;
  width: 44px;
  height: 44px;
  background-color: #fff;
  border-radius: 50%;
}
input:checked+label::before {
  content: attr(data-on-label);
  left: 7px;
  right: auto;
  color: #fff;
}
input:checked+label::after {
  left: 74px;
  background-color: #f7f7f7;
}
#demo01+label {
  background-color: #eee;
}
#demo01+label::before {
  color: #aaa;
}
#demo01:checked+label {
  background-color: #3498db;
}
#demo01:checked+label::before {
  color: #fff;
}
</style>





// WEBPACK FOOTER //
// src/views/Help/CategoryHelpBody.vue